import definitions from "../../../definitions";
import Enemy from "./Enemy";

export default class EnemyFlyingInsect extends Enemy {
    constructor(id) {
        super(id);

        this.moveSpeed = 1000;
        this.linearDamping = 6;
        this.collisionDamping = 12;

        this.hostile = false;

        this.collisionEnabled = false;
        this.alwaysUpdate = false;

        this.moveToTarget = null;
        this.moveToTargetOffset = new PIXI.Point();
        this.moveToTargetMinRadius = 10;
        this.moveToTargetMaxRadius = 80;

        this._flyTime = Math.random() * Math.PI * 2;
        this._flyTime2 = Math.random() * Math.PI * 2;

        this._defaultTween = null;
    }

    init() {
        super.init();

        this.moveToTarget = new PIXI.Point(this._initialPosition.x, this._initialPosition.y);
    }

    onViewAdded() {
        super.onViewAdded();

        this._view.anchor.set(0.5, 1);
        this._view.animationSpeed = 12;
        this._view.gotoAndPlay("idle", true);

        this.state = definitions.ENEMY_STATE.WANDER;
    }

    update() {
        super.update();

        if (this.moveToTarget) {
            const force = new P3.Vector2();
            const target = new PIXI.Point(this.moveToTarget.x + this.moveToTargetOffset.x, this.moveToTarget.y + this.moveToTargetOffset.y);

            this._moveToTarget(target, force);
            this.facingDirection = force.x;

            this.velocity.set(this.velocity.x + force.x * window.dt, this.velocity.y + force.y * window.dt);
        }
    }

    /**
     * @param {object} target
     * @param {P3.Vector2} force
     * @private
     */
    _moveToTarget(target, force) {
        let move = true;

        force.set(target.x - this.x, target.y - this.y);
        const distance = force.length;
        force.x /= distance;
        force.y /= distance;

        let targetSpeed = Math.min(1, (distance / this.moveToTargetMaxRadius)) * this.moveSpeed;
        if (distance < this.moveToTargetMinRadius) {
            move = false;
            targetSpeed = 0;
        }
        force.scaleBy(targetSpeed);
        return move;
    }

    /**
     * @param {number} state
     * @private
     */
    onStateEnter(state) {
        switch (state) {
            case definitions.ENEMY_STATE.WANDER: {
                break;
            }
        }
    }

    /**
     * @param {number} state
     * @private
     */
    onStateUpdate(state) {
        switch (state) {
            case definitions.ENEMY_STATE.WANDER: {
                this.moveToTarget.x = this._initialPosition.x + Math.sin(this._flyTime) * 100;
                this.moveToTarget.y = this._initialPosition.y + Math.sin(this._flyTime2 * 3) * 34 + Math.cos(this._flyTime) * 20;
                this._flyTime += window.dt;
                this._flyTime2 += window.dt;
                break;
            }
        }
    }

    /**
     * @param {number} state
     * @private
     */
    onStateExit(state) {
        switch (state) {
        }
    }

    /**
     * @param {number} amount
     * @return {boolean}
     */
    takeDamage(amount) {
        return false;
    }
}